import {
  Modal,
  Heading,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalCloseButton
} from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Loans } from './Loans/Loans'
import { EditLoan } from './EditLoan/EditLoan'
import { closeLoans } from '../../../actions/homeowner'
import { EditBalance } from './EditBalance/EditBalance'
import { selectLoanFocus } from '../../../store/selectors/home/homeowner'
import { selectLoanEditing, selectLoanEditingBalance } from '../../../store/selectors/loan'

export const MSG = defineMessages({
  head: {
    id: 'Mortgages.editBalance.tune',
    defaultMessage: 'Tune your Homebot'
  }
})

export const LoansModal = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const loanFocus = useSelector(selectLoanFocus)
  const editingLoan = useSelector(selectLoanEditing)
  const editingLoanBalance = useSelector(selectLoanEditingBalance)

  return (
    <Modal size='xl' isOpen={loanFocus} onClose={() => dispatch(closeLoans())}>
      <ModalOverlay />
      <ModalContent data-qa='MortgagesCard'>
        <ModalCloseButton />
        <ModalBody p={4}>
          <Heading mb={0} as='h3' size='3xs' textAlign='left' variant='eyebrow' color='brand' fontWeight='semibold'>
            {intl.formatMessage(MSG.head)}
          </Heading>
          {editingLoan && <EditLoan />}
          {editingLoanBalance && <EditBalance />}
          {!(editingLoan || editingLoanBalance) && <Loans />}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
